// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_ColumnDragObject__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: none;
  pointer-events: none;
}
.CSVImporter_ColumnDragObject__positioner {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 8em;
  width: 0;
  height: 0;
}
.CSVImporter_ColumnDragObject__holder {
  position: absolute;
  top: -0.75em;
  left: -0.75em;
  width: 100%;
  opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./components/csv_import/fields-step/ColumnDragObject.scss"],"names":[],"mappings":"AACE;EAEE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;AADJ;AAIE;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;AAHJ;AAME;EAEE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AALJ","sourcesContent":[".CSVImporter_ColumnDragObject {\n  &__overlay {\n    // scroll-independent container\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    overflow: none; // clipping to avoid triggering scrollbar when dragging near edges\n    pointer-events: none;\n  }\n\n  &__positioner {\n    // movement of mouse gesture inside overlay\n    position: absolute; // @todo this is not working with scroll\n    top: 0;\n    left: 0;\n    min-width: 8em; // in case could not compute\n    width: 0; // dynamically set at drag start\n    height: 0; // dynamically set at drag start\n  }\n\n  &__holder {\n    // placement of visible card relative to mouse pointer\n    position: absolute;\n    top: -0.75em;\n    left: -0.75em;\n    width: 100%;\n    opacity: 0.9;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
